import React, { Component, Fragment } from 'react'
import styles from './groups.styles'
import injectSheet from 'react-jss'
import Paper from 'pobble-components/dist/paper'
import ContentHolder from '../../content-holder/content-holder'
import GroupsTable from './groups-table/groups-table.container'
import LoadingScreen from './loading-screen/loading-screen'
import AddGroupDialog from './dialogs/add-group/add-group.container'
import UpdateGroupDialog from './dialogs/update-group/update-group.container'
import SetVisibilityDialog from './dialogs/set-visibility/set-visibility.container'
import GroupsBulkAction from './groups-bulk-action/groups-bulk-action.container'
import GroupsHead from './groups-head/groups-head.container'
import NoGroups from './no-groups/no-groups.container'

class Groups extends Component {
  componentDidMount() {
    this.props.onMount && this.props.onMount()
  }
  render() {
    const {
      classes,
      showGroupsTable,
      showLoadingScreen,
      actualGroupsEmpty
    } = this.props
    return (
      <ContentHolder className={classes.pageHolder}>
        <Paper>
          {showLoadingScreen && <LoadingScreen />}
          {showGroupsTable && (
            <div>
              <GroupsHead />
              <GroupsTable />
            </div>
          )}
          {actualGroupsEmpty && <NoGroups />}
          {showGroupsTable && (
            <Fragment>
              <UpdateGroupDialog />
              <SetVisibilityDialog />
            </Fragment>
          )}
          <AddGroupDialog />
        </Paper>
        <GroupsBulkAction />
      </ContentHolder>
    )
  }
}

export default injectSheet(styles)(Groups)
